import {
  APIendpoint,
  GET_DO_NOT_INTERACTS,
  GET_MORE_DO_NOT_INTERACTS,
  LOADING,
  getStoredToken
} from 'core/actions/constants'
import { GET } from 'core/api/legacyApi'
import { handleErrors } from 'core/helpers/handleErrors'

const getDoNotInteracts = ({ key, filters, nextUrl }) => {
  const { personId } = filters

  return async dispatch => {
    if (key) {
      dispatch({
        type: LOADING,
        key,
        status: 'loading'
      })
    }

    const endpoint =
      nextUrl || `${APIendpoint}/people/${personId}/do-not-interacts`
    const response = await fetch(endpoint, GET(getStoredToken()))
    const responseBody = await handleErrors(response)
    const isSuccess = response.status >= 200 && response.status <= 299

    if (isSuccess) {
      dispatch({
        type: nextUrl ? GET_MORE_DO_NOT_INTERACTS : GET_DO_NOT_INTERACTS,
        payload: responseBody.data,
        personId
      })

      if (responseBody.nextUrl) {
        dispatch(
          getDoNotInteracts({
            filters,
            nextUrl: responseBody.nextUrl
          })
        )
      }
    }

    if (key) {
      dispatch({
        type: LOADING,
        key,
        status: isSuccess ? 'success' : 'error'
      })
    }
  }
}

export default getDoNotInteracts
